@if (mainTabs.length > 1) {
  <icc-tabs [tabs]="mainTabs" [activeTabIndex]="initTab" (activated)="changedTab($event)"></icc-tabs>
}
@if (mode === 'list') {
  <div id="fillings-list" class='fillings-list'>
    <icc-list [searchable]="true"
      [items]="fillings"
      [selected]="selectedGlassIdForList"
      [itemTemplate]="'itemImgTitleDescription'"
      vertical="true"
      (select)="selectFilling($event)"
      (editGlazing)="openGlazingUnitModal($event)"
    ></icc-list>
  </div>
}
@if (mode === 'filters') {
  <div id="fillings-filters">
    <form [formGroup]="fillingFilters">
      @if (config().IccConfig.Configurators.fillingsSelect.showGlazingsForSliderValues && config().IccConfig.Configurators.fillingsSelect.securitySlider === 'general') {
        @if ((filtersLevels.generalSecurityLevel?.length > 1 && !isSliderDisabled)) {
          <h3>{{ 'WINDOW|Bezpieczeństwo' | translate}}</h3>
        }
        @if (filtersLevels.generalSecurityLevel?.length > 1) {
          <icc-slider  [steps]="filtersLevels.generalSecurityLevel" formControlName="generalSecurityLevel" (change)="getGlazingsForSecurityPackage($event.id)"></icc-slider>
        }
        @if (filtersLevels.generalSecurityLevel?.length > 1 && !isSliderDisabled) {
          <p>{{ generalSecurityDescription$ | async }}</p>
        }
      }
      @if ((filtersLevels.glassType?.length > 1 || getMatchingVariants().length > 0 && filtersLevels.glassType?.length > 1) && config().IccConfig.Configurators.fillingsSelect.glassTypeSelectionAsFirst) {
        <icc-select-box
          class="glass-type-select-box"
          [title]="(selectedGlassType?.name || '') + (selectedGlassTypeVariant?.name ? ':' : '')"
          [description]="selectedGlassTypeVariant?.name || ''"
          [imageUrl]="(selectedGlassTypeVariant?.image || '') ? ('/files/glasstypevariant/' + (selectedGlassTypeVariant?.image || '')) : ('/files/glasstype/' + (selectedGlassType?.image || ''))"
          [buttonText]="'INTERFACE|Zmień' | translate"
          [buttonText2]="'INTERFACE|Opcje' | translate"
          (select)="selectGlassType()"
          (select2)="selectGlassTypeVariant()"
          [disabledButton1]="filtersLevels.glassType?.length <= 1"
          [disabledButton2]="getMatchingVariants().length <= 1 || filtersLevels.glassType?.length <= 1"
        ></icc-select-box>
      }
      @if (config().IccConfig.Configurators.fillingsSelect.thermalTransmittanceSlider) {
        @if (filtersLevels.thermalTransmittance.length > 1) {
          <h3>{{ 'WINDOW|Przenikalność cieplna (Uw)' | translate}}</h3>
        }
        @if (filtersLevels.thermalTransmittance.length > 1) {
          <icc-slider [steps]="filtersLevels.thermalTransmittance" formControlName="thermalTransmittance" (change)="getGlazingsForSliderSettings()"></icc-slider>
        }
        @if (filtersLevels.thermalTransmittance.length > 1) {
          <p>{{ thermalTransmittanceDescription$ | async}}</p>
        }
      }
      @if (config().IccConfig.Configurators.fillingsSelect.glassCountSlider) {
        @if (filtersLevels.glassCount.length > 1 || config().IccConfig.Configurators.fillingsSelect.glassTypeSelectionAsFirst && filtersLevelsBeforeMatch.glassCount.length > 0) {
          <h3>{{ 'WINDOW|Liczba szyb' | translate}}@if (filtersLevels.glassCount.length === 1) {
            <span class="filling-filter-label">: {{ glassCountLabelAlt$ | async}}</span>
          }</h3>
        }
        @if (filtersLevels.glassCount.length > 1) {
          <icc-slider [steps]="filtersLevels.glassCount" formControlName="glassCount" (change)="getGlazingsForSliderSettings()"></icc-slider>
        }
        @if (filtersLevels.glassCount.length > 1) {
          <p>{{ glassCountDescription$ | async}}</p>
        }
      }
      @if (config().IccConfig.Configurators.fillingsSelect.securitySlider === 'detailed') {
        @if (filtersLevels.securityLevelOutside.length > 1 || config().IccConfig.Configurators.fillingsSelect.glassTypeSelectionAsFirst && filtersLevelsBeforeMatch.securityLevelOutside.length > 0) {
          <h3>{{ 'WINDOW|Bezpieczeństwo zewnętrzne' | translate}}@if (filtersLevels.securityLevelOutside.length === 1) {
            <span class="filling-filter-label">: {{ securityLevelOutsideLabelAlt$ | async}}</span>
          }</h3>
        }
        @if (filtersLevels.securityLevelOutside.length > 1) {
          <icc-slider [steps]="filtersLevels.securityLevelOutside" formControlName="securityLevelOutside" (change)="getGlazingsForSliderSettings()"></icc-slider>
        }
        @if (filtersLevels.securityLevelOutside.length > 1) {
          <p>{{ securityLevelOutsideDescription$ | async}}</p>
        }
        @if (filtersLevels.securityLevelInside.length > 1 || config().IccConfig.Configurators.fillingsSelect.glassTypeSelectionAsFirst && filtersLevelsBeforeMatch.securityLevelInside.length > 0) {
          <h3>{{ 'WINDOW|Bezpieczeństwo wewnętrzne' | translate}}@if (filtersLevels.securityLevelInside.length === 1) {
            <span class="filling-filter-label">: {{ securityLevelInsideLabelAlt$ | async}}</span>
          }</h3>
        }
        @if (filtersLevels.securityLevelInside.length > 1) {
          <icc-slider [steps]="filtersLevels.securityLevelInside" formControlName="securityLevelInside" (change)="getGlazingsForSliderSettings()"></icc-slider>
        }
        @if (filtersLevels.securityLevelInside.length > 1) {
          <p>{{ securityLevelInsideDescription$ | async}}</p>
        }
      }
      @if (config().IccConfig.Configurators.fillingsSelect.noiseProtectionSlider) {
        @if (filtersLevels.noiseProtection.length > 1 || config().IccConfig.Configurators.fillingsSelect.glassTypeSelectionAsFirst && filtersLevelsBeforeMatch.noiseProtection.length > 0) {
          <h3>{{ 'WINDOW|Ochrona przed hałasem' | translate}}@if (filtersLevels.noiseProtection.length === 1) {
            <span class="filling-filter-label">: {{ noiseProtectionLabelAlt$ | async}}</span>
          }</h3>
        }
        @if (filtersLevels.noiseProtection.length > 1) {
          <icc-slider [steps]="filtersLevels.noiseProtection" formControlName="noiseProtection" (change)="getGlazingsForSliderSettings()"></icc-slider>
        }
        @if (filtersLevels.noiseProtection.length > 1) {
          <p>{{ noiseProtectionDescription$ | async}}</p>
        }
      }
      @if ((filtersLevels.glassType.length > 1 || filtersLevels.glassType?.length === 1 && filtersLevels.glassTypeVariant.length > 1) && !config().IccConfig.Configurators.fillingsSelect.glassTypeSelectionAsFirst) {
        <h3>{{ 'WINDOW|Szyby specjalne' | translate}} </h3>
      }
      @if (filtersLevels.glassType?.length > 1 && !config().IccConfig.Configurators.fillingsSelect.glassTypeSelectionAsFirst) {
        <div class="glass-type-select">
          @for (type of filtersLevels.glassType; track type) {
            <div (click)="changeGlassType(type)" [class.selected]="fillingFilters.get('glassType')?.value === type?.id">
              <div class="item-imgTitle">
                <div class="icc-list-item-img-container">
                  <img class="item-imgTitle-img" [src]="('/files/glasstype/' + type.image)" [alt]="type.name" defaultImg>
                </div>
                <p class="item-imgTitle-title">{{ type.name }}</p>
              </div>
            </div>
          }
        </div>
      }
      @if (filtersLevels.glassType?.length === 1 && filtersLevels.glassTypeVariant.length && !config().IccConfig.Configurators.fillingsSelect.showGlazingsForSliderValues && !config().IccConfig.Configurators.fillingsSelect.glassTypeSelectionAsFirst) {
        <div class="glass-type-select">
          @for (type of filtersLevels.glassTypeVariant; track type) {
            <div (click)="changeGlassTypeVariant(type)" [class.selected]="fillingFilters.get('glassTypeVariant')?.value === type?.id">
              <div class="item-imgTitle">
                <div class="icc-list-item-img-container">
                  <img class="item-imgTitle-img" [src]="('/files/glasstypevariant/' + type.image)" [alt]="type.name" defaultImg>
                </div>
                <p class="item-imgTitle-title">{{ type.name }}</p>
              </div>
            </div>
          }
        </div>
      }
      @if (filtersLevels.glassType?.length === 1 && filtersLevels.glassTypeVariant.length > 1
        && config().IccConfig.Configurators.fillingsSelect.showGlazingsForSliderValues) {
        <div class="glass-type-select">
          @for (type of filtersLevels.glassTypeVariant; track type) {
            @for (glazing of availableGlazings; track glazing) {
              @if (type.id === glazing.filters.glassTypeVariant) {
                <div (click)="changeGlassTypeVariant(type)" [class.selected]="fillingFilters.get('glassTypeVariant')?.value == glazing.filters?.glassTypeVariant">
                  <div class="item-imgTitle">
                    <div class="icc-list-item-img-container">
                      <img class="item-imgTitle-img" [src]="('/files/glasstypevariant/' + type.image)" [alt]="type.name" defaultImg>
                    </div>
                    <p class="item-imgTitle-title">{{ type.name }}</p>
                  </div>
                </div>
              }
            }
          }
        </div>
      }
      @if (getMatchingVariants().length > 0 && filtersLevels.glassType?.length > 1 && !config().IccConfig.Configurators.fillingsSelect.glassTypeSelectionAsFirst) {
        <icc-select-box [title]="'WINDOW| Wariant szyby' | translate"
          [description]="selectedGlassTypeVariant?.name"
          [imageUrl]="'/files/glasstypevariant/' + (selectedGlassTypeVariant?.image || '')"
          [buttonText]="'INTERFACE|Zmień' | translate"
          (select)="selectGlassTypeVariant()"
        ></icc-select-box>
      }
    </form>
  </div>
}
@if (matchedFilling && mode !== 'list') {
  <div class="selected-summary mat-elevation-z4">
    <img [src]="'/files/filling/' + (matchedFilling?.image || '')" defaultImg>
    <p>{{ matchedFilling?.name }}</p>
    <button mat-raised-button (click)="select($event)" color="primary">{{ 'INTERFACE|Wybierz' | translate}}</button>
  </div>
}
